import { ApplicationConfig, provideZoneChangeDetection, isDevMode, inject } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';

import { routes } from './app.routes';
import { provideServiceWorker } from '@angular/service-worker';
import { ApiBaseUrlInterceptor } from './interceptors/api-base-url.interceptor';
import { TokenInterceptor } from './interceptors/token.interceptor';
import { PENDING_CHANGES_GUARD_CONFIG, PendingChangesGuard } from '@ticomix/angular-common';
import { KendoAlertService } from '@ticomix/angular-kendo';
import { ENVIRONMENT_PROVIDERS } from './core/config/environment.config';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),

    // Load environment configuration at startup
    ...ENVIRONMENT_PROVIDERS,

    provideServiceWorker('service-worker.js', {
      enabled: true,
      registrationStrategy: 'registerWhenStable:30000',
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiBaseUrlInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    PendingChangesGuard,
    {
      provide: PENDING_CHANGES_GUARD_CONFIG,
      useFactory: function () {
        const kendoAlertService = inject(KendoAlertService);
        return {
          confirmationCallback: async (message: string) => {
            return await kendoAlertService.confirmAsync(message);
          }
        }
      }
    }
  ]
};
